import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UploadResponse, FinalPayload, EntityUpdate, GroupPayload, GroupMetadataPayload, UpdateGroupPayload, PriorityUpdate, StatusUpdate, OperatorUpdate, DocumentNameUpdate } from './scans.interface';

@Injectable({
    providedIn: 'root'
})
export class ScansService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private fileUploadUrl = this.basePath + environment.interop.dgaspc.activitati.fileUpload;
    private submitFilesUrl = this.basePath + environment.interop.dgaspc.activitati.scans.storeScan;
    private downloadScanUrl = this.basePath + environment.interop.dgaspc.activitati.scans.downloadScan;
    private updateEntityUrl = this.basePath + environment.interop.dgaspc.activitati.scans.updateEntity;
    private getEntityUrl = this.basePath + environment.interop.dgaspc.activitati.scans.getScan;
    private storeGroupUrl = this.basePath + environment.interop.dgaspc.activitati.scans.storeGroup;
    private storeGroupMetadataUrl = this.basePath + environment.interop.dgaspc.activitati.scans.storeGroupMetadata;
    private updateGroupUrl = this.basePath + environment.interop.dgaspc.activitati.scans.updateGroup;
    private deleteGroupUrl = this.basePath + environment.interop.dgaspc.activitati.scans.deleteGroup;
    private updatePriorityUrl = this.basePath + environment.interop.dgaspc.activitati.scans.updatePriority;
    private updateStatusUrl = this.basePath + environment.interop.dgaspc.activitati.scans.updateStatus;
    private updateOperatorUrl = this.basePath + environment.interop.dgaspc.activitati.scans.updateAssignee;
    private updateDocumentNameUrl = this.basePath + environment.interop.dgaspc.activitati.scans.updateDocumentName;
    private finalizeGroupUrl = this.basePath + environment.interop.dgaspc.activitati.scans.finalizeGroup;
    private resetFinalizeGroupUrl = this.basePath + environment.interop.dgaspc.activitati.scans.resetFinalizeGroup;

    constructor(private http: HttpClient) { }

    fileUpload(formData: FormData): Observable<UploadResponse> {
        return this.http.post<UploadResponse>(this.fileUploadUrl, formData);
    }

    submitFiles(payload: FinalPayload[]): Observable<any> {
        return this.http.post<any>(this.submitFilesUrl, payload);
    }

    downloadScan(documentId: string | number): Observable<Blob> {
        return this.http.get(this.downloadScanUrl + documentId, {
            responseType: 'blob'
        });
    }

    updateEntity(payload: EntityUpdate) {
        return this.http.put(this.updateEntityUrl, payload);
    }

    getEntity(id: number) {
        return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(this.getEntityUrl + id);
    }

    storeGroup(payload: GroupPayload) {
        return this.http.post(this.storeGroupUrl, payload);
    }

    storeGroupMetadata(payload: GroupMetadataPayload) {
        return this.http.post(this.storeGroupMetadataUrl, payload);
    }

    updateGroup(payload: UpdateGroupPayload) {
        return this.http.put(this.updateGroupUrl, payload);
    }

    deleteGroup(groupId: number) {
        return this.http.delete(this.deleteGroupUrl + groupId);
    }

    updatePriority(payload: PriorityUpdate) {
        return this.http.put(this.updatePriorityUrl, payload);
    }

    updateStatus(payload: StatusUpdate) {
        return this.http.put(this.updateStatusUrl, payload);
    }

    updateOperator(payload: OperatorUpdate) {
        return this.http.put(this.updateOperatorUrl, payload);
    }

    updateDocumentName(payload: DocumentNameUpdate) {
        return this.http.put(this.updateDocumentNameUrl, payload);
    }

    finalizeGroup(id: number) {
        return this.http.put(this.finalizeGroupUrl + id, {});
    }

    resetFinalizeGroup(id: number) {
        return this.http.put(this.resetFinalizeGroupUrl + id, {});
    }
}
